(function() { window.GUID_aa8f65ad_829c_423d_bf62_8b509623e1a8 = { getGuid: function() { return "aa8f65ad-829c-423d-bf62-8b509623e1a8"; } }; })();
var CS;
(function (CS) {
    var Account;
    (function (Account) {
        function ShowValidateUserPopup(validateOnlyPassword, callback, onRefreshLayout = null) {
            var me = this;
            var popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: 'ValidateUserPopup',
                Url: CSParameters.BaseUrl + 'Account/ValidateUser/',
                Data: { validateOnlyPassword: validateOnlyPassword },
                Async: false,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPopupPositioned = function () {
                if (onRefreshLayout != null) {
                    onRefreshLayout(popup);
                }
            };
            popup.OnPosted = function (result) {
                callback(popup, $('#user_Password', popup.Content).val(), $('#user_Email', popup.Content).val());
            };
        }
        Account.ShowValidateUserPopup = ShowValidateUserPopup;
    })(Account = CS.Account || (CS.Account = {}));
})(CS || (CS = {}));

//# sourceMappingURL=ValidateUser.js.map
